import { useSelector } from 'react-redux';

import UnavailabilityRangeList from './UnavailabilityRangeList';

export default function UnavailableDrawerContent() {
  const { unavailable, date } = useSelector(
    (state) => state.singleUnavailability
  );

  return <UnavailabilityRangeList dayData={unavailable} date={date} />;
}
